// extracted by mini-css-extract-plugin
export default {"container":"YAxisSeparator_container__6II0d","svg":"YAxisSeparator_svg__PlWRz","line":"YAxisSeparator_line__M4Izm"};